import Sliders from './sliders';
import ImageGallery from './gallery';
const port = {
  Sliders,
  ImageGallery
};

export default port;
